<div class="person-desc">
  <div *ngIf="imageURL"
       (click)="enlargePic()"
       class="person-icon"
       [ngClass]="{'clickable':enableEnlargeImage}"
       [ngStyle]="{
              'background-image': 'url('+imageURL+'), url('+fallbackURL+')'
            }"
  >
  </div>
  <div>
    <div class="person-name-box">
      <div *ngIf="titelPre" class="title-pre">{{titelPre}}</div>
      <div  class="person-name" *ngIf="vorname && name">{{name + ' ' + vorname}}</div>
      <div  class="person-name" *ngIf="!vorname && name">{{name}}</div>
      <div  class="person-name" *ngIf="vorname && !name">{{vorname}}</div>
      <div *ngIf="titelPost"  class="title-post">{{titelPost}}</div>
    </div>
    <div class="mail-container" textSmall *ngIf="abteilung || mail || fest || mobil">
      <div class="kontakt-item" *ngIf="abteilung"><div>{{abteilung}}</div>
      </div>
      <div class="kontakt-item" *ngIf="mail"><a href="mailto:{{mail +(mailContent ? '?body='+mailContent:'')}}"
                                                title="E-Mail an {{mail}} senden">{{ mail }}</a>
      </div>
      <div class="kontakt-item" *ngIf="fest"><a href="tel:{{fest}}" title="{{fest}} anrufen">{{fest}}</a>
      </div>
      <div class="kontakt-item" *ngIf="mobil"><a href="tel:{{mobil}}" title="{{mobil}} anrufen">{{mobil}}</a>
      </div>
      <div class="kontakt-item" *ngIf="fax"><div>{{fax}}(Fax)</div>
      </div>
    </div>
    <ng-container *ngIf="subText && subText.length > 0">
      <ng-container *ngFor="let text of subText">
        <div class="mail-container" textSmall *ngIf="text">
          <div>{{text}}</div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
